import React from 'react';
import { Form, OverlayTrigger, Popover } from 'react-bootstrap-5';

type PopoverSelectProps = {
  active?: boolean;
  bodyClassName?: string;
  children?: React.ReactNode;
  className?: string;
  label: string;
  selectedLabel?: string;
}

export default function PopoverSelect({
  active,
  bodyClassName,
  children,
  className,
  label,
  selectedLabel
}: PopoverSelectProps) {
  return (
    <OverlayTrigger
      overlay={
        <Popover
          className={`popover-select overflow-hidden ${className ? className : ''}`}
          id={`popover-positioned-bottom`}
        >
          <Popover.Body
            className={`overflow-auto ${bodyClassName ? bodyClassName : ''}`}
            style={{ maxHeight: '500px' }}
          >
            {children}
          </Popover.Body>
        </Popover>
      }
      placement={'bottom'}
      rootClose
      trigger="click"
    >
      <Form.Group>
        <div className={`form-select as-button clickable text-truncate ${active || !!selectedLabel ? 'active' : ''}`}>
          {selectedLabel || label}
        </div>
      </Form.Group>
    </OverlayTrigger>
  );
}
